import React from "react";
import BookingFlowTotal from "../BookingFlowTotal";
import BookingVouchers from "../../BookingVouchers/BookingVouchers";

export default class BookingVouchersTab extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Vouchers" style={{ margin: "0 15px" }}>
        <div className="row">
          <div className="col-sm-7">
            <BookingVouchers {...this.props} />
          </div>
          <div className="col-sm-5">
            <div className="BookingTotal">
              <BookingFlowTotal
                {...this.props}
              />
              {this.props.vouchers && this.props.vouchers.length ? 
              <button type="button" onClick={() => this.props.onChangeStep('total') } className="btn btn-block btn-primary">
                {I18n.t("checkout")}
              </button>
              :
              null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
